import { Icon } from '../../../../Icon';
import { DisclaimerMarker } from '../../../../Disclaimer';
import * as T from './typography';

export const defaultComponents = {
  p: T.Paragraph,
  h1: T.H1,
  h2: T.H2,
  h3: T.H3,
  h4: T.H4,
  h5: T.H5,
  h6: T.H6,
  ul: T.UL,
  ol: T.OL,
  li: T.LI,
  strong: T.Strong,
  sup: T.Superscript,
  sub: T.Subscript,
  icon: Icon,
  img: T.IconImage,
  a: T.CTALink,
  disclaimerMarker: DisclaimerMarker,
};

export const headingComponents = {
  h1: T.H1,
  h2: T.H2,
  h3: T.H3,
  h4: T.H4,
  h5: T.H5,
  h6: T.H6,
  p: T.H2,
  img: T.IconImage,
  a: T.CTALink,
};
